import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useRoomSize } from "./hooks";

export const QuestionRoomSize = () => {
	const { roomSize, onSetRoomSize, isEdited, hasError } = useRoomSize();

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"部屋の広さ"}
			guide="提供される部屋の広さを設定しましょう。"
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<QuestionSectionWrapper>
					<InputNumberField
						handleInput={onSetRoomSize}
						value={roomSize?.value ?? undefined}
						errorMessage={roomSize?.error}
					/>
					<p>㎡</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionRoomSize.displayName = "QuestionRoomSize";
